import { __extends } from "tslib";
import { release, warning } from '@awayfl/swf-loader';
import { NativeMenu } from '../display/NativeMenu';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: ContextMenu
var partialImp = function (obj, field) { return warning("[Builtins] Partial implemented " + obj.constructor.name + "::" + field); };
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu() {
        var _this = _super.call(this) || this;
        _this._builtInItems = new _this.sec.flash.ui.ContextMenuBuiltInItems();
        _this._customItems = [];
        return _this;
    }
    Object.defineProperty(ContextMenu, "isSupported", {
        get: function () {
            partialImp(ContextMenu, 'get isSupported');
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "builtInItems", {
        get: function () {
            // TODO: Should clone here probably.
            release || partialImp(this, 'get builtInItems');
            return this._builtInItems;
        },
        set: function (value) {
            // TODO: Should clone here probably.
            value = value;
            release || partialImp(this, 'set builtInItems');
            this._builtInItems = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "customItems", {
        get: function () {
            // TODO: Should clone here probably.
            release || partialImp(this, 'get customItems');
            return this.sec.createArrayUnsafe(this._customItems);
        },
        set: function (value) {
            // TODO: Should clone here probably.
            value = value;
            release || partialImp(this, 'set customItems');
            this._customItems = value.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "link", {
        get: function () {
            release || partialImp(this, 'get link');
            return this._link;
        },
        set: function (value) {
            value = value;
            release || partialImp(this, 'set link');
            this._link = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "clipboardMenu", {
        get: function () {
            release || partialImp(this, 'get clipboardMenu');
            return this._clipboardMenu;
        },
        set: function (value) {
            value = !!value;
            release || partialImp(this, 'set clipboardMenu');
            this._clipboardMenu = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "clipboardItems", {
        get: function () {
            release || partialImp(this, 'get clipboardItems');
            return this._clipboardItems;
        },
        set: function (value) {
            value = value;
            release || partialImp(this, 'set clipboardItems');
            this._clipboardItems = value;
        },
        enumerable: true,
        configurable: true
    });
    ContextMenu.prototype.hideBuiltInItems = function () {
        var items = this.builtInItems;
        if (!items) {
            return;
        }
        items.save = false;
        items.zoom = false;
        items.quality = false;
        items.play = false;
        items.loop = false;
        items.rewind = false;
        items.forwardAndBack = false;
        items.print = false;
    };
    ContextMenu.prototype.clone = function () {
        var result = new this.sec.flash.ui.ContextMenu();
        result._builtInItems = this._builtInItems.clone();
        this.cloneLinkAndClipboardProperties(result);
        var customItems = this._customItems;
        for (var i = 0; i < customItems.length; i++) {
            result._customItems.push(customItems[i].clone());
        }
        return result;
    };
    ContextMenu.prototype.cloneLinkAndClipboardProperties = function (c) {
        c = c;
        release || partialImp(this, 'cloneLinkAndClipboardProperties');
        return;
    };
    ContextMenu.classInitializer = null;
    return ContextMenu;
}(NativeMenu));
export { ContextMenu };
